import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MedicalCaseIconComponent } from '@kuiper/icons';
import { MaintenanceModeService } from '../../services/maintenance-mode/maintenance-mode.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lib-site-redirect-notice',
  imports: [MedicalCaseIconComponent, TranslocoPipe, FormsModule],
  templateUrl: './site-redirect-notice.component.html',
  styleUrl: './site-redirect-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SiteRedirectNoticeComponent {
  maintenanceModeService = inject(MaintenanceModeService);

  show = computed(() => this.maintenanceModeService.showSiteRedirectNotice());

  // Set the new domain here
  targetDomain = 'https://areeb.dib.i-business.app';
  oldUrl = signal('');

  transformedUrl = computed(() => {
    const url = this.oldUrl();
    if (!url) return '';

    try {
      // Try to parse the input URL
      const parsedUrl = new URL(
        url.startsWith('http') ? url : `https://${url}`
      );
      const parsedTarget = new URL(this.targetDomain);

      // Replace only protocol, host and port
      parsedUrl.protocol = parsedTarget.protocol;
      parsedUrl.host = parsedTarget.host;
      parsedUrl.port = parsedTarget.port;

      return parsedUrl.toString();
    } catch {
      // Return empty if invalid URL
      return '';
    }
  });
}
